import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosInstance } from "../../utils/axios/requestInfo";

import { api } from "../../resources/api";
import { INotice } from "./types";

const PLACEMENTS = ["CLUB_CARD", "SUBSCRIPTION_CARD", "CHECKOUT_CONSENT", "ACTIVE_SUBSCRIPTION"];

// Отбрасываем всё, что не похоже на объявление: бэкенд новый, лучше перестраховаться
const isNotice = (item: any): item is INotice =>
  !!item &&
  typeof item.id === "number" &&
  typeof item.text === "string" &&
  item.text.trim().length > 0 &&
  PLACEMENTS.includes(item.placement);

// Объявления клуба (например, «бассейн закрыт с ... по ...»).
// Fail-open: при ошибке возвращаем null — в слайсе остаётся прежний список,
// страницы работают как без объявлений.
export const fetchNotices = createAsyncThunk<INotice[] | null>(
  "notices/fetchNotices",
  async () => {
    try {
      const response = await axiosInstance.get(api.club.NOTICES);
      if (!Array.isArray(response.data)) {
        return null;
      }

      return response.data.filter(isNotice).map((item: any) => ({
        id: item.id,
        placement: item.placement,
        text: item.text,
        variant: item.variant === "warning" ? "warning" : "info",
        membership_ids: Array.isArray(item.membership_ids)
          ? item.membership_ids.map((membershipId: any) => String(membershipId))
          : [],
        sort_order: typeof item.sort_order === "number" ? item.sort_order : 0,
      }));
    } catch (error: any) {
      return null;
    }
  }
);
